import { Form, Modal } from "antd";
import { useEffect, useState } from "react";
import { postAddVenue } from "services/SauceService";
import venueWorkingHours from "./weekHoursDefault.json";
import { useDispatch, useSelector } from "react-redux";
import {
  getBusinessInfo,
  getBusinessSubscription,
} from "redux-context/business";
import { VenueFormFields } from "components/venue-form-fields/VenueFormFields";

interface ModalVenueProps {
  open: boolean;
  onCancel: () => void;
  onSave: (venue: any) => void;
  initialSearch?: string;
}

const ModalVenue: React.FC<ModalVenueProps> = (props) => {
  const { open, onCancel, onSave, initialSearch } = props;
  const dispatch = useDispatch<any>();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState<boolean>(false);

  const { business } = useSelector((state: any) => state.business);

  const onFinishForm = async () => {
    try {
      setLoading(true);
      const values = form.getFieldsValue(true);
      const params = {
        ...values,
        businessId: business._id,
      };
      const response: any = await postAddVenue(params);
      if (response) {
        dispatch(getBusinessSubscription());
        dispatch(getBusinessInfo());
        onSave(response?.venue);
      }
    } catch (error) {
      console.error("Error adding venue:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    form.resetFields();
  }, [open, form]);

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      onOk={onFinishForm}
      title="Add another location"
      cancelButtonProps={{ type: "link" }}
      okText="Add location"
      okButtonProps={{ loading }}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          pocs: [
            {
              name: "",
              email: "",
              notifyEmail: false,
              phone: "",
            },
          ],
          venueWorkingHours,
        }}
        style={{ overflow: "auto", height: 550 }}
      >
        <VenueFormFields
          business={business}
          initialSearch={initialSearch}
          open={open}
        />
      </Form>
    </Modal>
  );
};

export default ModalVenue;
